import React, { useCallback, useEffect, useState } from 'react';

import { HiLockClosed } from 'react-icons/hi2';
import { useParams } from 'react-router-dom';

import CommunityAPI from '../../api/CommunityAPI';
import {
  setActiveSection,
  setChannelPageActiveTab,
  setSelectedChannelData,
} from '../../context/communityReducer';
import { isChannelLocked } from '../../shared/communityUtils';
import showAppError from '../../shared/error';
import { useAppDispatch, useAppSelector } from '../../shared/hooks';
import {
  CommunityChannelTabs,
  ICommunityChannelTabTypes,
} from '../../types/communityTypes';
import { Onboarding } from '../../types/userTypes';
import NoDataFound from '../Feed/components/NoDataFound/NoDataFound';
import CommunityChannelPostList from './CommunityPost/CommunityChannelPostList';
import CommunityChatRoom from './components/CommunityChatRoom';

type Props = {};

const CommunityChannel: React.FC<Props> = () => {
  const { channelId } = useParams();
  const dispatch = useAppDispatch();
  const { channelPageActiveTab, selectedChannelData, userCommunityAccess } =
    useAppSelector((state) => state.community);
  const { subscribedMangoes } = useAppSelector((state) => state.mango);
  const { type } = useAppSelector((state) => state.user);
  // const channelId = useMemo(() => {
  //   return selectedChannelData?._id;
  // }, [selectedChannelData?._id]);

  const [loader, setLoader] = useState(false);

  const searchParams = new URLSearchParams(window.location.search);
  const queryTagValue = searchParams.get('tab');

  const setInitialTabForPage = useCallback(() => {
    const communityTabTypeList: ICommunityChannelTabTypes[] =
      Object.values(CommunityChannelTabs);
    if (!queryTagValue && channelPageActiveTab !== CommunityChannelTabs.FEED) {
      dispatch(setChannelPageActiveTab(CommunityChannelTabs.FEED));
    } else if (
      queryTagValue &&
      communityTabTypeList.includes(
        queryTagValue as ICommunityChannelTabTypes,
      ) &&
      channelPageActiveTab !== queryTagValue
    ) {
      dispatch(
        setChannelPageActiveTab(queryTagValue as ICommunityChannelTabTypes),
      );
    }
  }, [channelPageActiveTab, dispatch, queryTagValue]);

  const fetchChannelDetails = useCallback(async () => {
    if (!channelId) return;
    try {
      setLoader(true);
      const resp = await CommunityAPI.getChannelDetailsById(channelId);
      if (resp?.status === 200) {
        const channelData = resp?.data?.result;
        const newMangoArr = channelData?.mangoArr?.map((each) => each?._id);
        const newBedgeArr = channelData?.badgeArr?.map((each) => each?._id);
        const newGroupArr = channelData?.groupArr?.map((each) => each?._id);
        // const isLocked = isChannelLocked(newMangoArr, newBedgeArr);
        dispatch(
          setSelectedChannelData({
            ...channelData,
            mangoArr: newMangoArr,
            badgeArr: newBedgeArr,
            groupArr: newGroupArr[0],
            // isLocked,
          }),
        );
        dispatch(setChannelPageActiveTab(resp?.data?.result?.features[0]));
        dispatch(
          setActiveSection({
            activeSection: resp?.data?.result?._id,
            headerTitle: resp?.data?.result?.name,
          }),
        );
      } else {
        showAppError(resp?.data);
      }
    } catch (error) {
      showAppError(error);
    } finally {
      setLoader(false);
    }
  }, [channelId, dispatch]);

  const communityChannelVisitAction = useCallback(async () => {
    if (!selectedChannelData?._id) return;
    if (type !== Onboarding.FAN_COMPLETED) return;
    try {
      const resp = await CommunityAPI.visitCommunityChannel(
        selectedChannelData?._id,
      );
      if (resp?.status === 204) {
        console.log(resp?.data);
      }
    } catch (error) {
      console.log(error);
    }
  }, [selectedChannelData?._id, type]);

  useEffect(() => {
    if (!selectedChannelData?._id) return;
    const isLocked = isChannelLocked(
      selectedChannelData?.mangoArr || [],
      selectedChannelData?.badgeArr || [],
    );
    console.log(isLocked);
    dispatch(
      setSelectedChannelData({
        ...selectedChannelData,
        isLocked,
      }),
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    selectedChannelData?._id,
    dispatch,
    userCommunityAccess.accessBadges,
    subscribedMangoes,
    selectedChannelData?.mangoArr,
    selectedChannelData?.badgeArr,
  ]);

  useEffect(() => {
    setInitialTabForPage();
    fetchChannelDetails();
    communityChannelVisitAction();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [channelId]);

  useEffect(() => {
    return () => {
      dispatch(setSelectedChannelData(null));
    };
  }, [dispatch]);

  const displaySelectedTabComponent = useCallback(() => {
    if (selectedChannelData?.isLocked) {
      return (
        <NoDataFound
          title={`Channel locked!`}
          subtitle="This channel is currently locked and cannot be accessed."
          subtitle2="For more details or to gain access, please contact the creator."
          iconElement={<HiLockClosed size={40} />}
        />
      );
    }
    if (channelPageActiveTab === 'feed') {
      return <CommunityChannelPostList />;
    }
    if (channelPageActiveTab === 'messages') {
      return (
        <CommunityChatRoom
          channelRoomId={selectedChannelData?.chatRoom}
          hideHeader
          isCommunityChannelPage
        />
      );
    }
    return null;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    channelPageActiveTab,
    selectedChannelData?.chatRoom,
    selectedChannelData?.isLocked,
    subscribedMangoes,
  ]);

  if (!selectedChannelData?._id || loader) {
    return <div>Loading...</div>;
  }

  return (
    <>
      <div
        className={`feed__content ${
          channelPageActiveTab === 'messages' ? 'message-wrapper' : ''
        }`}>
        {loader ? null : displaySelectedTabComponent()}
      </div>
    </>
  );
};

export default CommunityChannel;
